import { render, staticRenderFns } from "./TgMerchantCheckBoxDialog.vue?vue&type=template&id=2f348fec"
import script from "./TgMerchantCheckBoxDialog.vue?vue&type=script&lang=js"
export * from "./TgMerchantCheckBoxDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports